import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { DBService } from 'src/app/core/backend-adapter/db.service';
import { GBPService } from 'src/app/gbp-management/gbp.service';
import { GbpPhotoDetailsComponent } from '../gbp-photo-details/gbp-photo-details.component';
import {NotifyService} from '@app/core/layouts/notifications/notify/notify.service';
import {GbpQaAddLocationComponent} from '@app/gbp-management/gbp-tab-qa/components/gbp-qa-add-location/gbp-qa-add-location.component';

@Component({
  selector: 'app-gbp-photo-locations',
  templateUrl: './gbp-photo-locations.component.html',
  styleUrls: ['./gbp-photo-locations.component.scss'],
})
export class GbpPhotoLocationsComponent implements OnInit, OnDestroy {
  tableData;
  isPagination = false;
  bulkOwner = false;
  id: number;
  offset = 0;
  pageSize = 20;
  paginatorRows = 20;
  paginatorLength = 0;
  loading: boolean;
  whereClaus: any[] = [];

  constructor(
    public dynamicDialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private dbService: DBService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    this.tableData = this.dynamicDialogConfig?.data?.locations;
    this.isPagination = Boolean(this.dynamicDialogConfig?.data?.isPagination);
    this.id = this.dynamicDialogConfig?.data?.id;
  }

  private getAllLocationDetails() {
    this.loading = true;
    this.dbService.MediaDetailGMB.loadObjects({
      offset: this.offset,
      limit: this.pageSize,
      'detailLevel': 3,
      where: this.whereClaus,
    })
      .then(
        (repl) => {
          if (repl.collection?.length == 0) {
            this.notifyService.error('There are no locations available');
            this.tableData = [];
            this.paginatorLength = 0;
          } else {
            this.tableData = repl.collection;
            this.paginatorLength = repl.totalEntries;
          }
        },
        (err: Error) => {
          this.tableData = [];
          console.warn('Error loading Locations: %j', err);
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }

  onPageChange(event) {
    this.offset = event.first;
    this.pageSize = event.rows;
    this.whereClaus = this.buildWhereClaus(event.globalFilter || '');
    this.getAllLocationDetails();
  }

  updateTableData(event) {
    this.offset = event.first;
    this.whereClaus = this.buildWhereClaus(event.globalFilter || '');
    this.getAllLocationDetails();
  }

  buildWhereClaus(search) {
    const tempFilterArr: string[] = [];
    let whereClauseArray: Array<any> = ['-and', `batch_id=${this.id}`];
    const pushQueriesToMainArray = () => {
      whereClauseArray.push(...tempFilterArr);
      tempFilterArr.length = 0;
    };
    if (search) {
      tempFilterArr.push(`l.storeCode::text ~* '\\y${search}'`);
      // tempFilterArr.push(`l.businessName::text ~* '\\y${search}'`);
      pushQueriesToMainArray();
    }
    return whereClauseArray;
  }

  ngOnDestroy(): void {
  }
}
